import { contactUsPostCallWrapper } from "../apiCaching/POST-Requests/apiContactCallWrapper";
import { cityNameValidation, getBrandData, handleBookingSubmit, handleCheckboxChangeUtility, stateNameValidation, zipCodeValidation } from "../apiCaching/POST-Requests/helperModules/handleBookingSubmit";
import { isTestEnvironment } from "../apiCaching/POST-Requests/helperModules/helperFunctions";
import { BookingPayloadModel } from "../apiCaching/POST-Requests/interface/booking/bookingInterface";
import { errorMessage } from "../common/errorMessages";
import { apiConfig } from "../config/apiConfig";
import { REGEX } from "../constants/regex";
import { getCountryCode } from "../location-search-map/getCountryCode";
import { bookingPayload } from "../mly/booking-payload";
import { disclaimerHandleCheck, DisclaimerServiceIdentifier } from "../util/disclaimerService";
import { getAllAddressList, discoverSuggestions, discoverSuggestionsFilter, discoveryAPI, getAddressDetails, handleMissingData, NO_CITY_FOUND, NO_STATE_FOUND } from "../util/discovery";
import { DomainIdentifier } from "../util/domainService";
import { handleMobileInput } from "../util/errorHandlers";
import { StateHandler } from "../util/getStateFun";
import { gtmCustomEventLeadFlow } from "../util/gtm-custom-event-lead-flow";
import { hideTermsPolicy, toggleTermsPolicyBasedOnCountry } from "../util/hideTermsPolicy";
import { startLoader, stopLoader } from "../util/loader";
import { LocalizationIdentifier } from "../util/localizationService";
import { debounce,getBrandDetailsFromBrandJson, getCampaignName, getFranchiseDetails, removeAllEventListeners } from "../util/share";

export class ReferralService {
    bookingPayload: any;
    sendButton: any;
    referFirstName: any;
    referLasttName: any;
    referPhone: any;
    referZipCode: any;
    referEmail: any;
    referralFirstName: any;
    referralLastName: any;
    referralPhone: any;
    referralZipCode: any;
    referralEmail: any;
    referralAddress: any;
    referralAddress2: any;
    sentCommentAndNote :boolean = false;
    private readonly shortFormService: NodeListOf<HTMLElement>;
    private noteWithRequestBody: any;

    constructor() {
        this.init();
        this.bookingPayload = bookingPayload;
        this.shortFormService = document.querySelectorAll('[id*="short-form-service-reminder"]');
        document.querySelector('.cta-wrapper .primary-btn')?.addEventListener("click", () => {
            const enteredAddr = this.referralAddress?.value.concat(" ", this.referralAddress2.value, " ", this.bookingPayload.PostalCode);
            const suggestAddr = this.referralAddress?.getAttribute("data-suggestion") as any;
            let output: any;
            const suggestAddrInp = document.getElementById('suggested-address-radio') as HTMLInputElement;
            sessionStorage.setItem("suggestion", "true");
            if (suggestAddrInp?.checked) {
                const suggestJSON = suggestAddr !=='undefned' && JSON.parse(suggestAddr);
                output = suggestJSON?.address.label;
                this.referralAddress.value = output;
                const suggestedAddress = getAddressDetails(suggestJSON?.address);
                sessionStorage.setItem('suggestedAddress', JSON.stringify(suggestedAddress));
            }
            else {
                output = enteredAddr;
            }
            sessionStorage.setItem('sAddressParam', output);
            this.onReferralButtonClick();
        });
    }

    public init() {
        this.initInputs();
        this.initButtonEvent();
        this.setupInlineValidation();
    }

    private handleNextBtnClick() {
        const inputAddressBumper = document.querySelector('.step-2 #modal-address-1') as HTMLInputElement;
        const inputAddressBumper2 = document.querySelector('.step-2 #modal-address-2') as HTMLInputElement;
        const inputCity = document.querySelector('.step-2 #modal-city') as HTMLInputElement;
        const inputState1 = document.querySelector('.step-2 #modal-states') as HTMLInputElement;
        const inputZipCode = document.querySelector('.step-2 #modal-zipcode') as HTMLInputElement;
        const sAddressBumper = inputAddressBumper?.value.trim() || '';
        const sAddressBumper1 = inputAddressBumper2?.value.trim() || '';
        const sCityBumper = inputCity?.value.trim() || '';
        const sStateBumper = inputState1?.value.trim() || '';
        const sZipCodeBumper = inputZipCode?.value.trim() || '';
        const sAddressParam = `${sAddressBumper} ${sAddressBumper1} ${sCityBumper} ${sStateBumper} ${sZipCodeBumper}`;
        if (this.validateForm()) {
            this.franchiseLookupAddressApi(sZipCodeBumper,true,sAddressParam);
        }
    }

    public initInputs() {
        
        // Referee inputs variables declaration
        this.referFirstName = document.getElementById('my-refer-fname');
        this.referLasttName = document.getElementById('my-refer-lname');
        this.referPhone = document.getElementById('my-refer-phone');
        this.referZipCode = document.getElementById('my-refer-zip-code');
        this.referEmail = document.getElementById('my-refer-email');

        // Referal inputs variables declaration
        this.referralFirstName = document.getElementById('frnd-refer-fname');
        this.referralLastName = document.getElementById('frnd-refer-lname');
        this.referralPhone = document.getElementById('frnd-refer-phone');
        this.referralZipCode = document.getElementById('frnd-refer-zip-code');
        this.referralEmail = document.getElementById('frnd-refer-email');
        this.referralAddress = document.getElementById('frnd-refer-address');
        this.referralAddress2 = document.getElementById('frnd-refer-address2');
        this.addInputEventListeners();
        
        this.shortFormService?.forEach((checkbox) => {
            checkbox.addEventListener('change', () => handleCheckboxChangeUtility('.refer-wrapper'));
        });
        const brandDetails = localStorage.getItem('brandDetails');
        if(brandDetails){
            const brandData = JSON.parse(brandDetails);
            if(brandData?.send_lead_referrer_info){
                this.referZipCode?.addEventListener('focusout', this.handleFocusOut.bind(this,this.referZipCode));
            }else{
                this.referralZipCode?.addEventListener('focusout', this.handleFocusOut.bind(this,this.referralZipCode));
            }
        }
        const localisation = DomainIdentifier();
        const countryCode = getCountryCode();
        const localisedcountryCode = sessionStorage.getItem('countryCode');
        if (localisation == 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca') {
            hideTermsPolicy('#referral-form', 'terms-policy-text');
        }
    }
    

   handleFocusOut(zipCodeInput: any) {
        const zipCode = zipCodeInput?.value.trim();
        DisclaimerServiceIdentifier(zipCode);
        toggleTermsPolicyBasedOnCountry('#referral-form', zipCode);
    }

    public addInputEventListeners() {

        if (this.referFirstName) {
            this.referFirstName.addEventListener('input', () => this.handleCommonInputError(this.referFirstName, `${this.referFirstName.id}-error-msg`, REGEX.sendName, errorMessage.fname));
        }
        if (this.referLasttName) {
            this.referLasttName.addEventListener('input', () => this.handleCommonInputError(this.referLasttName, `${this.referLasttName.id}-error-msg`, REGEX.sendName, errorMessage.lname));
        }
        if (this.referPhone) {
            this.referPhone.addEventListener('input', handleMobileInput.bind(this));
        }

        if (this.referZipCode) {
            this.referZipCode.addEventListener('input', () => this.handleCommonInputError(this.referZipCode, `${this.referZipCode.id}-error-msg`, REGEX.sendZip, errorMessage.zip));
        }
        if (this.referEmail) {
            this.referEmail.addEventListener('input', () => this.handleCommonInputError(this.referEmail, `${this.referEmail.id}-error-msg`, REGEX.sendEmail, errorMessage.email));
        }
        if (this.referralFirstName) {
            this.referralFirstName.addEventListener('input', () => this.handleCommonInputError(this.referralFirstName, `${this.referralFirstName.id}-error-msg`, REGEX.sendName, errorMessage.fname));
        }
        if (this.referralLastName) {
            this.referralLastName.addEventListener('input', () => this.handleCommonInputError(this.referralLastName, `${this.referralLastName.id}-error-msg`, REGEX.sendName, errorMessage.lname));
        }
        if (this.referralPhone) {
            this.referralPhone.addEventListener('input', handleMobileInput.bind(this));
        }
        if (this.referralZipCode) {
            this.referralZipCode.addEventListener('input', () => this.handleCommonInputError(this.referralZipCode, `${this.referralZipCode.id}-error-msg`, REGEX.sendZip, errorMessage.zip));
        }
        if (this.referralEmail) {
            this.referralEmail.addEventListener('input', () => this.handleCommonInputError(this.referralEmail, `${this.referralEmail.id}-error-msg`, REGEX.sendEmail, errorMessage.email));
        }

        if (this.referralAddress) {
            this.referralAddress.addEventListener('input', () => this.handleCommonInputError(this.referralAddress, `${this.referralAddress.id}-error-msg`, REGEX.sendAddress1, errorMessage.address));
            const debouncedSetAutoSuggested = debounce(this.setAutoSuggested.bind(this), 300);
            this.referralAddress.addEventListener('input',debouncedSetAutoSuggested);
        }

        if (this.referralAddress2) {
            this.referralAddress2.addEventListener('input', () => this.handleCommonInputError(this.referralAddress2, `${this.referralAddress2.id}-error-msg`, REGEX.sendAddress2, errorMessage.address2));
        }
    }

    private readonly debouncedSearch = debounce(async (zipCode: string, address: string) => {
        const pocFlag = true;
        if (pocFlag) {
            const referralAddressVal = this.referralAddress.value?.trim() ?? "";
            if (referralAddressVal?.length >= 3) {
                await discoverSuggestionsFilter(zipCode, address, referralAddressVal);
            }
        }
        else {
            await discoverSuggestions(zipCode, address);
        }
    }, 500);

    private setAutoSuggested = async (e: any) => {
        e.preventDefault()
        sessionStorage.setItem("suggestion", "false");
        this.referralAddress.removeAttribute("suggestion");
        sessionStorage.setItem("manualCity", "");
        sessionStorage.setItem("manualState", "");
        this.debouncedSearch(this.referralZipCode, this.referralAddress);
    }

    public initButtonEvent() {
        const referralButton = document.querySelector('.refer-wrapper .primary-btn');
        if (referralButton) {
            referralButton.addEventListener('click', () => this.onReferralButtonClick());
        }
    }

    public async onReferralButtonClick() {
        console.log('Referral button clicked');
        if (this.validateFields()) {

            startLoader();
            console.log('All fields are valid');
            try {
                this.readFormData();
                const data = this.getReferralFormData();
                console.log('Referral form data:', data);
                const addrFlag = sessionStorage.getItem("suggestion");
                const brandData = await getBrandData();
                const enteredAddr = this.referralAddress?.value.concat(" ", this.referralAddress2.value, " ", this.bookingPayload.PostalCode);
                const suggestAddr = this.referralAddress?.getAttribute("data-suggestion") as string;
                if (addrFlag === "false" && suggestAddr != null && suggestAddr !== 'undefined' && enteredAddr) {
                    this.openPropertyValidationModal(enteredAddr, suggestAddr);
                } else {
                    let zipCode = '';
                    if (brandData?.send_lead_referee_info) {
                        zipCode = data.referralZipCode;
                    } else if (brandData?.send_lead_referrer_info) {
                        zipCode = data.referZipCode;
                    }
                    if (zipCode) {
                        this.franchiseLookupAddressApi(zipCode);
                    }else{
                        // Display the error msg if zipcode is empty
                        stopLoader();
                        this.handleButtonClickAndError('referal-form-error-modal-id', 'refer-form-system-error');
                    }

                }
            } catch (e) {
                console.log('Error while submitting referral form', e);
            }
        }
    }


    public async franchiseLookupAddressApi(zipCode: any, isAddressBumper: boolean = false,sAddressParam ='') {
        if (!zipCode) return;
        try {
            const result = await getFranchiseDetails(isAddressBumper ? sAddressParam : zipCode); // IsRoundRobin is true
            if (isAddressBumper) this.closeAddressBumperForm();
            await this.handleApiResponse(result, zipCode);
        } catch (error: any) {
            await this.handleError(error, zipCode);
        }
    }

    public async handleApiResponse(result: any, zipCode: any) {
        if (result?.length == 0) {
            await this.handleNoServiceArea();
        } else if (result?.length > 0) {
            this.bookingApiCall(result[0], zipCode);
        }
    }

    public async handleNoServiceArea() {
        stopLoader();
        const brandData = await getBrandData();
        if (!brandData?.send_lead_refer_contactus_api) {
            const btnClick = document.getElementById('referal-form-error-modal-id');
            btnClick?.click();
            const noServiceEle = document.getElementById('refer-form-no-service');
            if (noServiceEle) {
                noServiceEle.classList.remove('hidden');
                const referSystemError = document.getElementById('refer-form-system-error');
                if (referSystemError) {
                    referSystemError.classList.add('hidden');
                }
            }
        } else {
            this.contactUsApiCall();
        }
    }


    private async handleError(error: any,zipCode: any) {
        stopLoader();
        const brandData = await getBrandData();
        if (typeof error?.then === 'function') {
            error = await error;
            }
            
            let message = error?.response?.data?.message;
            if(!message){
                message = error?.message;
            } 
            if(!message){
                message = '';
            }
           
            if (message.toLowerCase() === "full address is needed to narrow down results") {
                const step1 = document.querySelector('.step-1') as HTMLElement;
                if (step1) {
                    step1.classList.add('hidden');
                }
                const stateHandler = new StateHandler();
                stateHandler.getStateFun();
                const findLocalBtn = document.querySelector(".find-local") as HTMLElement;
                findLocalBtn?.click();
                const step2 = document.querySelector('.step-2') as HTMLElement;
                if (step2) {
                    step2.classList.remove('hidden');
                    step2.classList.add('block');
                    const closeLocalModal = document.querySelector('.close-modal-btn');
                    closeLocalModal?.addEventListener('click', function handleClick(event) {
                        step2.classList.add("hidden");
                        step1.classList.remove("hidden");
                    });
                }

                const modalZipCode = document.querySelector('.step-2 #modal-zipcode') as HTMLInputElement;
                modalZipCode.value = zipCode;

                
                this.sendButton = removeAllEventListeners('.step-2 .form-cta button');
                if (this.sendButton) {
                    this.sendButton.addEventListener("click", this.handleNextBtnClick.bind(this));
                }
            } else {
            this.handleGenericError(brandData);
        }
    }

    public handleGenericError(brandData: any) {
        stopLoader();
        if (!brandData.send_lead_refer_contactus_api) {
            const btnClick = document.getElementById('referal-form-error-modal-id');
            btnClick?.click();
            const zipMessage = document.getElementById('modal-zipcode-error');
            if (zipMessage) {
                zipMessage.innerHTML = `We're sorry. Something went wrong. Please try again later.`;
            }
        } else {
            this.contactUsApiCall();
        }
    }

    public async bookingApiCall(result: any, zipCode: any) {
        startLoader();
        const { franchiseWebLocationId, franchiseId } = result;
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const campaignName = getCampaignName();
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        let formData: any = await this.getFormData(brandData, zipCode);
        let { city, state, finalAddress } = this.getAddressDetails(formData,brandData);
        let requestBody = this.createRequestBody(formData, city, state, finalAddress, zipCode, conceptCode, campaignName, brandData, franchiseWebLocationId, franchiseId);
        const out = await handleMissingData(requestBody.city, requestBody.state, requestBody.zipCode);
        requestBody.city = out?.city || requestBody.city;
        requestBody.state = out?.state || requestBody.state;

        try {  
            const domain = DomainIdentifier();
            const localisation = LocalizationIdentifier();
            // Default value to pass if checkbox is not found
            let checkboxId = '';
            
            if (((domain === "us" && !localisation) || (domain === "us" && localisation=="us"))) {
                checkboxId = 'referral-form-service-reminder-us';
            } else {
                checkboxId = 'referral-form-service-reminder-ca';
            }
            const referForm:any = document.querySelector('.refer-wrapper');
            this.noteWithRequestBody = disclaimerHandleCheck(false, referForm, requestBody, requestBody.zipCode,checkboxId);
            requestBody = this.noteWithRequestBody;

        } catch (error) {
            console.error('An error occurred in disclaimerHandleCheck in Refer file:', error);
        }

        sessionStorage.setItem('booking', JSON.stringify(requestBody));
        
        await handleBookingSubmit(
            requestBody,
            'opus_refferal_form_submit_ev',
            'referal-form-error-modal-id',
            'refer-form-system-error',
            'refer-form-no-service',
            this.redirectConfirmationPage.bind(this)
        );
    }

    public async getFormData(brandData: any, zipCode: any) {
        if (brandData.send_lead_referee_info) {
            return this.getRefereeFormData();
        } else if (brandData.send_lead_referrer_info) {
            return await this.getReferrerFormData(zipCode);
        }
        return {};
    }

    private getRefereeFormData() {
        let fName = this.referralFirstName?.value;
        let lastName = this.referralLastName?.value;

        if (!lastName) {
            const names = this.splitName(fName);
            fName = names.fName;
            lastName = names.lastName;
        }

        return {
            fName: fName ?? '',
            lastName: lastName ?? ' ',
            email: this.referralEmail?.value ?? '',
            phone: this.referralPhone?.value ?? '',
            address: this.referralAddress?.value ?? '',
            address2: this.referralAddress2?.value ?? '',
        };
    }

    private async getReferrerFormData(zipCode: any) {
        const resultAdd = await discoveryAPI(zipCode);
        const outputData = resultAdd?.items[0];
        let fName = this.referFirstName?.value;
        let lastName = this.referLasttName?.value;

        if (!lastName) {
            const names = this.splitName(fName);
            fName = names.fName;
            lastName = names.lastName;
        }

        const formData: any = {
            fName: fName ?? '',
            lastName: lastName ?? ' ',
            email: this.referEmail.value ?? '',
            phone: this.referPhone.value ?? '',
            address: (document.getElementById('default_address_refer_a_friend') as HTMLInputElement)?.value ?? "No Address collected",
            address2: ''
        };

        if (outputData?.address?.city) {
            formData.city = outputData?.address?.city;
        }
        if (outputData?.address?.stateCode) {
            formData.state = outputData?.address?.stateCode;
        }

        return formData;
    }

    private splitName(name: string) {
        try {
            const nameParts = name?.split(' ');
            return { fName: nameParts[0], lastName: nameParts[1] };
        } catch (error) {
            console.error('Error splitting name:', error);
            return { fName: name ?? '', lastName: ' ' };
        }
    }

    public getAddressDetails(formData: any,brandData: any) {
        let item = getAllAddressList()?.filter((item: any) => item.title.trim() == formData?.address?.trim())[0];
        let manualCity = sessionStorage.getItem("manualCity");
        let manualState = sessionStorage.getItem("manualState");
        let city = manualCity || item?.address.city || NO_CITY_FOUND;
        let state = manualState || item?.address.state || NO_STATE_FOUND;

        let finalAddress: any = '';
        let getsuggestionFlag = sessionStorage.getItem("suggestion");
        const suggestAddr = sessionStorage.getItem('suggestedAddress') as string;
        
        if (getsuggestionFlag === "true" && suggestAddr && brandData?.send_lead_referee_info) {
            city = JSON.parse(suggestAddr).city;
            state = JSON.parse(suggestAddr).stateCode;
            finalAddress = JSON.parse(suggestAddr).addr1;
        } else {
            finalAddress = formData?.address;
            if(brandData?.send_lead_referrer_info){
                city = formData?.city;
                state = formData?.state;
            }
        }

        return { city, state, finalAddress };
    }

    public createRequestBody(formData: any, city: string, state: string, finalAddress: string, zipCode: string, conceptCode: string, campaignName: string, brandData: any, franchiseWebLocationId: any, franchiseId: any) {
        const conceptId = (document.getElementById('conceptId') as HTMLInputElement)?.value;
        const url = window.location.href;
        let vendorId;
        let vendorName;

        if (brandData) {
            vendorId = brandData.vendorId;
            vendorName = brandData.vendorName;
        }

        const emailOptOut = brandData.enable_emailOptOut;
        const defaultLeadSourceId = brandData.default_leadSourceID || 0;

        let noteComment = brandData?.refer_note_text || '';
        const requestBody: BookingPayloadModel = {
            isLocalized: true,
            firstName: formData.fName,
            lastName: formData.lastName,
            zipCode: zipCode.trim(),
            postalCode: zipCode.trim(),
            email: formData.email,
            state: state,
            city: city,
            phone: formData.phone,
            address: finalAddress,
            address2: formData?.address2 ?? '',
            comments: '',
            signUpForUpdates: false,
            conceptId: Number(conceptId),
            currentPage: url,
            leadSource: brandData?.refer_a_friend_lead_source || "WEB",
            leadOrigin: brandData?.refer_a_friend_lead_origin || "WEB",
            phoneType: '',
            isLeadOnly: true,
            campaignName: campaignName || 'N/A',
            callType: "WEB",
            conceptCalledId: Number(conceptId),
            emailOptOut: emailOptOut,
            vendorId: Number(vendorId),
            isTest: isTestEnvironment(),
            conceptCode: conceptCode,
            vendorName: vendorName,
            customerType: 'Residential',
            leadSourceId: defaultLeadSourceId,
            note: noteComment,
            webLocationId: 0
        };

        if (franchiseWebLocationId) {
            requestBody.webLocationId = franchiseWebLocationId;
        }
        if (franchiseId) {
            requestBody.franchiseId = franchiseId;
        }

        function formatField(label: string, value: string | null | undefined): string {
            return value ? `${label}: ${value}, ` : '';
        }
        
        const getReferralFormData = this.getReferralFormData();
        let mergeAllFields = brandData?.send_lead_referee_info
        ? `<br>${formatField('First Name', getReferralFormData?.referFirstName)}${formatField('Last Name', getReferralFormData?.referLastName)}${formatField('Email', getReferralFormData?.referEmail)}${formatField('Phone', getReferralFormData?.referPhone)} ${formatField('Zip Code', getReferralFormData?.referZipCode)}`
        : `<br>${formatField('Referral First Name', getReferralFormData?.referralFirstName)}${formatField('Referral Last Name', getReferralFormData?.referralLastName)}${formatField('Referral Email', getReferralFormData?.referralEmail)}${formatField('Referral Phone', getReferralFormData?.referralPhone)}${formatField('Referral Address', getReferralFormData?.referralAddress)}${formatField('Referral Address 2', getReferralFormData?.referralAddress2)}${formatField('Referral Zip Code', getReferralFormData?.referralZipCode)}`;
    
        // Remove the trailing comma and space
        mergeAllFields = mergeAllFields.slice(0, -2);
        console.log(mergeAllFields)
        requestBody.note += mergeAllFields;
        console.log(requestBody.note)

        if (brandData.send_lead_referrer_info) {
            requestBody.referralFirstName = this.referralFirstName.value;
            requestBody.referralLastName = this.referralLastName.value;
            requestBody.referralZipCode = this.referralZipCode.value;
            requestBody.referralPhone = this.referralPhone.value;
            requestBody.referralEmail = this.referralEmail.value;
            requestBody.referralReason = '';
        }

        if (this.sentCommentAndNote) {
            requestBody.comments = noteComment;
        }

        return requestBody;
    }

    async contactUsApiCall() {
        startLoader();
        const conceptCode = document.getElementById('conceptCode') as HTMLInputElement;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode?.value);
        const formData = this.getReferralFormData();

        // Determine which form data to use based on brandData.send_lead_referee_info and brandData.send_lead_referrer_info
        let selectedFormData;
        if (brandData?.send_lead_referee_info) {
            selectedFormData = {
                firstName: formData.referralFirstName,
                lastName: formData.referralLastName,
                zipCode: formData.referralZipCode,
                phone: formData.referralPhone,
                email: formData.referralEmail,
                address: formData.referralAddress,
                address2: formData.referralAddress2,
                comments:''
                
            };
        } else if (brandData?.send_lead_referrer_info) {
            const resultAdd = await discoveryAPI(formData.referZipCode);
            const outputData = resultAdd?.items[0];
            selectedFormData = {
                firstName: formData.referFirstName,
                lastName: formData.referLastName,
                zipCode: formData.referZipCode,
                phone: formData.referPhone,
                email: formData.referEmail,
                address: (document.getElementById('default_address_refer_a_friend') as HTMLInputElement)?.value ?? "No Address collected",
                address2: '',
                city: '',
                state: '',
                country: '',
                comments: ''
                
            };
            if (outputData?.address?.city) {
                selectedFormData.city = outputData?.address?.city;
            }
            if (outputData?.address?.stateCode) {
                selectedFormData.state = outputData?.address?.stateCode;
            }

            if (outputData?.address?.countryCode) {
                selectedFormData.country = outputData?.address?.countryCode;
            }

        }

       
        const conceptId = document.getElementById('conceptId') as HTMLInputElement;
        let vendorId;
        let vendorName;

        try {
            if (brandData) {
                vendorId = brandData.vendorId;
                vendorName = brandData.vendorName;
            }

            let requestBody = this.contactCreateRequestBody(selectedFormData, conceptId, vendorId, vendorName, brandData);
            
            function formatField(label: string, value: string | null | undefined): string {
                return value ? `${label}: ${value}, ` : '';
            }
            let mergeAllFields = brandData?.send_lead_referee_info
            ? `${formatField('First Name', formData?.referFirstName)}${formatField('Last Name', formData?.referLastName)}${formatField('Email', formData?.referEmail)}${formatField('Phone', formData?.referPhone)} ${formatField('Zip Code', formData?.referZipCode)}`
            : `${formatField('Referral First Name', formData?.referralFirstName)}${formatField('Referral Last Name', formData?.referralLastName)}${formatField('Referral Email', formData?.referralEmail)}${formatField('Referral Phone', formData?.referralPhone)}${formatField('Referral Address', formData?.referralAddress)}${formatField('Referral Address 2', formData?.referralAddress2)}${formatField('Referral Zip Code', formData?.referralZipCode)}`;
        
            // Remove the trailing comma and space
            mergeAllFields = mergeAllFields.slice(0, -2);
            
            requestBody.comments = brandData?.refer_note_text_contactus ?? '';
            if(requestBody.comments){
                requestBody.comments +=" , "+ mergeAllFields;
            }else{
                requestBody.comments += mergeAllFields;
            }
            try {  
                const domain = DomainIdentifier();
                const localisation = LocalizationIdentifier();
                // Default value to pass if checkbox is not found
                let checkboxId = '';
                
                if (((domain === "us" && !localisation) || (domain === "us" && localisation=="us"))) {
                    checkboxId = 'referral-form-service-reminder-us';
                } else {
                    checkboxId = 'referral-form-service-reminder-ca';
                }
                const referForm:any = document.querySelector('.refer-wrapper');
                this.noteWithRequestBody = disclaimerHandleCheck(false, referForm, requestBody, requestBody.zipCode,checkboxId);
                requestBody = this.noteWithRequestBody;
    
            } catch (error) {
                console.error('An error occurred in disclaimerHandleCheck in Refer file:', error);
            }

            await this.contactCallContactUsEndpoint(requestBody);
            stopLoader();
        } catch (error) {
            console.error(`Error in Referral>index.ts file in the contactUsApiCall function while fetching the Brand JSON. Error message: ${error}`);
            stopLoader();
        }
    }

    private contactCreateRequestBody(formData: any, conceptId: any, vendorId: any, vendorName: any, brandData: any) {

        let city = sessionStorage.getItem('manualCity');
        let state = sessionStorage.getItem('manualState');
        let country = sessionStorage.getItem('countryName');

        let getsuggestionFlag = sessionStorage.getItem("suggestion");
        const suggestAddr = sessionStorage.getItem('suggestedAddress') as string;

        if (getsuggestionFlag === "true" && suggestAddr && brandData?.send_lead_referee_info) {
              city = JSON.parse(suggestAddr).city;
              state = JSON.parse(suggestAddr).stateCode;
              country = JSON.parse(suggestAddr).country;
        }else {
                city = "";
                state = "";
                country = "";
            if(brandData?.send_lead_referrer_info){
                city = formData?.city;
                state = formData?.state;
                country = formData?.country;
            }
        }
        

        const getDefault = (value: any, defaultValue: any = '') => value ?? defaultValue;
    
        return {
            firstName: getDefault(formData.firstName),
            lastName: getDefault(formData.lastName),
            zipCode: getDefault(formData.zipCode).trim(),
            phone: getDefault(formData.phone),
            email: getDefault(formData.email),
            city: getDefault(city),
            state: getDefault(state),
            country: getDefault(country),
            address: getDefault(formData.address),
            address2: getDefault(formData.address2),
            signUpForUpdates: false,
            isLocalized: false,
            comments:'',
            isTest: isTestEnvironment(),
            conceptId: Number(getDefault(conceptId?.value)),
            vendorId: Number(getDefault(vendorId)),
        };
    }

    private async contactCallContactUsEndpoint(requestBody: any) {
        try {
            await contactUsPostCallWrapper(apiConfig.CONTACT_US_SEND, requestBody);
            const submitObj = {
                event: 'opus_refferal_form_submit_ev',
                status: 'success'
            }
            gtmCustomEventLeadFlow(submitObj);
            this.redirectConfirmationPage();
        } catch (error) {
            const submitObj = {
                event: 'opus_refferal_form_submit_ev',
                status: 'failure'
            }
            gtmCustomEventLeadFlow(submitObj);
            console.error(`Error in Referral >  file in the contactCallContactUsEndpoint function while calling the contactus endpoint: ${error}`);
        }
    }

    public readFormData() {
        this.bookingPayload.FirstName = this.referFirstName ? this.referFirstName.value : '';
        this.bookingPayload.LastName = this.referLasttName ? this.referLasttName.value : '';
        this.bookingPayload.Phone = this.referPhone ? this.referPhone.value : '';
        this.bookingPayload.ZipCode = this.referralZipCode ? this.referralZipCode.value : '';
        this.bookingPayload.PostalCode = this.referralZipCode ? this.referralZipCode.value : '';
        this.bookingPayload.Email = this.referEmail ? this.referEmail.value : '';
        this.bookingPayload.Address = this.referralAddress ? this.referralAddress.value : '';
        this.bookingPayload.Address2 = this.referralAddress2 ? this.referralAddress2.value : '';
        this.bookingPayload.LeadSource = "Referral";
        this.bookingPayload.LeadOrigin = "Referral";
        this.bookingPayload.CampaignName = "Referral";
        this.bookingPayload.TagName = "Referral";
        this.bookingPayload.ServiceText = "Lead Only";
        this.bookingPayload.ServiceID = 0;
        this.bookingPayload.Warranty = false;
        this.bookingPayload.TimeSlotTypeId = 0;
        this.bookingPayload.MakeId = 0;
        this.bookingPayload.LeadSourceId = 0;
        this.bookingPayload.VendorId = 0;
        this.bookingPayload.ConceptId = 0;

    }

    openPropertyValidationModal(addressParam: string, suggestStr: any) {
        stopLoader();
        const callPopupModal = document.getElementById('address-modal')
        callPopupModal?.click()
        const enteredAddr = document.querySelector('label[for="entered-address-radio"]');
        const suggestAddr = document.querySelector('label[for="suggested-address-radio"]');
        const suggestJSON = suggestStr !=='undefined' && JSON.parse(suggestStr);
        if (enteredAddr && suggestAddr) {
            enteredAddr.textContent = addressParam;
            suggestAddr.textContent = suggestJSON.address.label;
        }
       

    }

    public getReferralFormData() {
        return {
            referFirstName: this.referFirstName ? this.referFirstName.value : '',
            referLastName: this.referLasttName ? this.referLasttName.value : '',
            referPhone: this.referPhone ? this.referPhone.value : '',
            referZipCode: this.referZipCode ? this.referZipCode.value : '',
            referEmail: this.referEmail ? this.referEmail.value : '',
            referralFirstName: this.referralFirstName ? this.referralFirstName.value : '',
            referralLastName: this.referralLastName ? this.referralLastName.value : '',
            referralPhone: this.referralPhone ? this.referralPhone.value : '',
            referralZipCode: this.referralZipCode ? this.referralZipCode.value : '',
            referralEmail: this.referralEmail ? this.referralEmail.value : '',
            referralAddress: this.referralAddress ? this.referralAddress.value : '',
            referralAddress2: this.referralAddress2 ? this.referralAddress2.value : ''
        };
    }

    public validateFields(): boolean {
        try {
            document.querySelectorAll('.invalid-field').forEach((e: any) => e.classList.remove('invalid-field'));
            const errors: any = {};

            const validateField = (field: HTMLInputElement, regex: RegExp, errorMessage: string) => {
                if (field?.value === '') {
                    errors[field?.id] = '';
                } else if (field?.value !== '' && !regex.test(field?.value)) {
                    errors[field?.id] = errorMessage;
                } else if (field?.value && (field?.id === 'frnd-refer-phone' || field?.id === 'my-refer-phone') && field?.value.length < 14) {
                    errors[field?.id] = errorMessage;
                }
            };

            if (this.referFirstName) {
                validateField(this.referFirstName, REGEX.sendName, errorMessage.fname);
            }
            if (this.referLasttName) {
                validateField(this.referLasttName, REGEX.sendName, errorMessage.lname);
            }
            if (this.referPhone) {
                validateField(this.referPhone, REGEX.mobileNumberRegex, errorMessage.phone);
            }
            if (this.referZipCode) {
                validateField(this.referZipCode, REGEX.sendZip, errorMessage.zip);
            }
            if (this.referEmail) {
                validateField(this.referEmail, REGEX.sendEmail, errorMessage.email);
            }
            if (this.referralFirstName) {
                validateField(this.referralFirstName, REGEX.sendName, errorMessage.fname);
            }
            if (this.referralLastName) {
                validateField(this.referralLastName, REGEX.sendName, errorMessage.lname);
            }
            if (this.referralPhone) {
                validateField(this.referralPhone, REGEX.mobileNumberRegex, errorMessage.phone);
            }
            if (this.referralZipCode) {
                validateField(this.referralZipCode, REGEX.sendZip, errorMessage.zip);
            }
            if (this.referralEmail) {
                validateField(this.referralEmail, REGEX.sendEmail, errorMessage.email);
            }
            if (this.referralAddress) {
                validateField(this.referralAddress, REGEX.sendAddress1, errorMessage.address);
            }

            Object.keys(errors).forEach((fieldId, index) => {
                const field: any = document.getElementById(`${fieldId}`);
                const fieldError: any = document.getElementById(`${fieldId}-error-msg`);
                if (field?.parentNode) {
                    const errorMessage = errors[fieldId];
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${fieldId}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    if (fieldError?.classList.contains('hidden')) {
                        fieldError.classList.remove('hidden');
                    }
                }
                if (index === 0 && field) {
                    field.focus();
                }
            });

            return Object.keys(errors).length === 0;
        } catch (error) {
            console.error('Error validating fields:', error);
            return false;
        }
    }

    public handleCommonInputError(inputElement: any, errorId: any, validationRegex: any, errorMessage: any) {
        const getErrMsg = (document.getElementById(errorId) as HTMLElement)?.getAttribute('aria-describedby');
        const fieldError = document.getElementById(errorId) as HTMLElement;

        if (inputElement.value !== '' && !validationRegex.test(inputElement?.value?.trim())) {
            if (fieldError) {
                fieldError.classList.remove('hidden');
                fieldError.innerHTML = getErrMsg ?? errorMessage;
            }
        } else {
            inputElement.classList.remove("invalid-field");
            if (fieldError) {
                fieldError.classList.add('hidden');
            }
        }
    }

    public redirectConfirmationPage() {
        const referralRedirectionUrl = (document.getElementById('referral-redirect') as HTMLInputElement)?.value;
        if (referralRedirectionUrl) {
            window.location.href = referralRedirectionUrl;
        }
    }

    public closeAddressBumperForm(){
            // const findLocalBtn = document.querySelector("#glb-find-local") as HTMLElement;
            // if (findLocalBtn) {
            //     findLocalBtn.classList.add("hidden");
            //     document.querySelectorAll("body > div[modal-backdrop]")?.forEach((e)=>e?.remove())
            // }
            const findLocalBtn = document.querySelector(".find-local") as HTMLElement;
            findLocalBtn?.click();
    }

    private setupInlineValidation(): void {
        const fields = {
          address1: document.getElementById('modal-address-1') as HTMLInputElement,
          address2: document.getElementById('modal-address-2') as HTMLInputElement,
          city: document.getElementById('modal-city') as HTMLInputElement,
          state: document.getElementById('modal-states') as HTMLSelectElement,
          zipCode: document.getElementById('modal-zipcode') as HTMLInputElement
        };
    
        fields.address1?.addEventListener('input', (e) => this.validateField(e.target as HTMLInputElement, () => this.addressValidation(fields.address1.value, true)));
        fields.address2?.addEventListener('input', (e) => this.validateField(e.target as HTMLInputElement, () => this.addressValidation(fields.address2.value, false)));
        fields.city?.addEventListener('input', (e) => this.validateField(e.target as HTMLInputElement, () => this.cityValidation(fields.city.value)));
        fields.zipCode?.addEventListener('input', (e) => this.validateField(e.target as HTMLInputElement, () => this.zipValidation(fields.zipCode.value)));
        fields.state?.addEventListener('change', (e) => this.validateField(e.target as HTMLSelectElement, () => this.stateValidation(fields.state.value)));
      }

      private validateField(element: HTMLInputElement | HTMLSelectElement, validationFunction: () => string): void {
        const error = validationFunction();
        const errorElement = element.nextElementSibling as HTMLSpanElement;
        if (error) {
          element.classList.add('invalid-field');
          if (errorElement?.classList.contains('error-msg')) {
            errorElement.textContent = error;
          } else {
            const newErrorElement = document.createElement('span');
            newErrorElement.className = 'error-msg';
            newErrorElement.textContent = error;
            element.parentNode?.insertBefore(newErrorElement, element.nextSibling);
          }
        } else {
          element.classList.remove('invalid-field');
          if (errorElement?.classList.contains('error-msg')) {
            errorElement.remove();
          }
        }
      }

      private addressValidation(inputVal: string, isRequired: boolean): string {
        const addrRegex = REGEX.noBracketAddress;
        if (isRequired) {
          if (!inputVal.trim()) {
            return 'Address Line 1 is required.';
          }
          if (!addrRegex.test(inputVal)) {
            return 'Enter valid address.';
          }
        } else if (inputVal.trim() && !addrRegex.test(inputVal)) {
            return 'Enter valid address.';
        }
        return '';
      }
    
      private zipValidation(inputVal: string): string {
       return zipCodeValidation(inputVal);
      }
    
      private cityValidation(inputVal: string): string {
        return cityNameValidation(inputVal);
      }
    
      private stateValidation(inputVal: string): string {
        return stateNameValidation(inputVal);
      }
      private getFormFields(): any {
        const fields = {
    
          zipCode: (document.getElementById('modal-zipcode') as HTMLInputElement).value,
          address1: (document.getElementById('modal-address-1') as HTMLInputElement).value,
          address2: (document.getElementById('modal-address-2') as HTMLInputElement).value,
          city: (document.getElementById('modal-city') as HTMLInputElement).value,
          state: (document.getElementById('modal-states') as HTMLSelectElement).value,
        };
        return fields;
      }
      
      public validateForm(): boolean {
        const formFields = this.getFormFields();
        document.querySelectorAll('.step-2 .error-msg').forEach(e => e.remove());
        document.querySelectorAll('.invalid-field').forEach(e => e.classList.remove('invalid-field'));
        let errors: { [key: string]: string } = {};
        errors['modal-address-1'] = this.addressValidation(formFields.address1, true);
        errors['modal-address-2'] = this.addressValidation(formFields.address2, false);
        errors['modal-zipcode'] = this.zipValidation(formFields.zipCode);
        errors['modal-city'] = this.cityValidation(formFields.city);
        errors['modal-states'] = this.stateValidation(formFields.state);
    
        Object.keys(errors).forEach((fieldId) => {
          const field: any = document.getElementById(fieldId);
          if (field && field.parentNode) {
            const errorMessage = errors[fieldId];
            if (errorMessage) {
              const errorElement = document.createElement('span');
              errorElement.className = 'error-msg';
              errorElement.textContent = errorMessage;
              field.classList.add("invalid-field");
              field.parentNode.appendChild(errorElement);
            }
          }
        });
    
        return Object.values(errors).every(error => !error);
      }

      public handleButtonClickAndError(buttonId: string, errorMessageId: string) {
        const btnClick = document.getElementById(buttonId);
        const errorMessage = document.getElementById(errorMessageId);
    
        if (btnClick) {
            btnClick.click();
        }
    
        if (errorMessage) {
            errorMessage.classList.remove('hidden');
            const referNoServiceError = document.getElementById('refer-form-no-service');
            if(referNoServiceError){
                referNoServiceError.classList.add('hidden');
            }
        }
    }
}

if (!(globalThis as any).__ReferralServiceListenerAdded) {
  (globalThis as any).__ReferralServiceListenerAdded = true;

  document.addEventListener('DOMContentLoaded', () => {
    if ((globalThis as any).__ReferralServiceInitialized) return;

    const referralDom = document.querySelector('.refer-wrapper');
    if (referralDom) {
      (globalThis as any).__ReferralServiceInitialized = true;
       const referralService = new ReferralService();
    }
  });
}